import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Form } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { motivoPrenotazioniFuture, useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { tipologiaStruttura } from "../../../../components/Util/enum";
import { nomiSport } from "../../../../components/Util/sportProdotto";
import AdminUserLessonsTable from "../userLessons/index";
import { VAT_OPTIONS, findVatOption } from '../../../../components/Util/vatOptions';

export const AdminLessonsView = () => {
    const { id } = useParams();

	const [loadingShowed, setLoadingShowed] = useState(false);
	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ]

    const dayOptions = [
        { value: 'MONDAY', label: 'Lunedì' },
        { value: 'TUESDAY', label: 'Martedì' },
        { value: 'WEDNESDAY', label: 'Mercoledì' },
        { value: 'THURSDAY', label: 'Giovedì' },
        { value: 'FRIDAY', label: 'Venerdì' },
        { value: 'SATURDAY', label: 'Sabato' },
        { value: 'SUNDAY', label: 'Domenica' }
    ]


    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);

    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });

    const [availableTeachers, setAvailableTeachers] = useState([]);
    
	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const bookingLessons = await apiClient.getBookingLessonById(token, id);
					setLoadingShowed(false);
                    
                    if(bookingLessons) {
                        const elementFormData = {
                            id: bookingLessons.id,
                            clubId: bookingLessons.clubId,
                            name: bookingLessons.name, 
                            sportNames: nomiSport(bookingLessons),
                            type: bookingLessons.type || 'CLOSED',
                            standard_price: bookingLessons.standard_price,
                            vat_rate: bookingLessons.vat_rate,
                            vat_nature: bookingLessons.vat_nature,
                            iva_5_percent: bookingLessons.iva_5_percent,
                            member_price: bookingLessons.member_price,
                            federated_price: bookingLessons.federated_price,
                            fitcoin_cashback: bookingLessons.fitcoin_cashback,
                            payable_in_club: bookingLessons.payable_in_club,
                            payable_stripe: bookingLessons.payable_stripe,
                            payable_bank: bookingLessons.payable_bank,
                            status: bookingLessons.status,
                            description: bookingLessons.description,
                            lessonPicture: bookingLessons.lessonPicture,
                            coachId: bookingLessons.coachId || '',
                            venueId: bookingLessons.venueId || '',
                            startDate: bookingLessons.startDate || '',
                            endDate: bookingLessons.endDate || '',
                            weeklySchedule: bookingLessons.weeklySchedule || [],
                            clubName: bookingLessons.clubName || 'N/A'
                        }
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
    }, [id]);

    const [formData, setFormData] = useState({
        id: '',
        clubId: '',
        name: '', 
        sportNames: '',
        type: 'CLOSED',
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        status: '',
        lessonPicture: '',
        coachId: '',
        venueId: '',
        venue_name: ''
    });

    // Titolo della pagina = nome della lezione, appena caricato.
    usePageTitle(formData?.name);

    // Stato nella tendina accanto al titolo: si salva subito (regola SUI). Il super admin lo cambia per
    // qualsiasi struttura; una bozza resta «Bozza» (si attiva dalla scheda della struttura).
    const cambiaStato = async (attiva) => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        if (!attiva) {
            // Non si disattiva se ci sono lezioni prenotate da oggi in poi
            const prenotazioni = await apiClient.getUserBookingLessons(token, id);
            if (prenotazioni?.error) return { error: prenotazioni.error };
            const motivo = motivoPrenotazioniFuture(prenotazioni, 'la lezione');
            if (motivo) return { error: motivo.replace('disattivarlo', 'disattivarla') };
        }
        const nuovo = attiva ? 'PURCHASABLE' : 'CANCELLED';
        const result = await apiClient.changeLessonStatus(token, id, nuovo);
        if (result && result.error) return { error: result.error };
        setFormData(prev => ({ ...prev, status: nuovo }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!formData?.status,
        attivo: formData?.status === 'PURCHASABLE',
        bozza: formData?.status === 'DRAFT',
        onCambia: cambiaStato,
    });

    const renderEditableField = (fieldName, label, type, options = null, isBoolean = false) => {
        const value = formData[fieldName];
        
        return (
            <div>
                <Form.Label>{label}</Form.Label>
                {type === 'select' && options ? (
                    <Select
                        isDisabled
                        value={options.find(option => option.value === value)}
                        options={options}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                backgroundColor: '#f2f2f2',
                                color: 'rgba(108,117,125,0.6)',
                                border: '1px solid #ced4da'
                            }),
                            singleValue: (provided) => ({
                                ...provided,
                                color: 'rgba(108,117,125,0.6)'
                            })
                        }}
                    />
                ) : type === 'textarea' ? (
                    <Form.Control
                        disabled
                        as="textarea"
                        rows={3}
                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal"}}
                        className="mt-2"
                        name={fieldName}
                        value={value || ''}
                    />
                ) : type === 'number' && fieldName.includes('price') ? (
                    <Form.Control
                        disabled
                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal"}}
                        className="mt-2"
                        type="text"
                        name={fieldName}
                        value={value + ' €'}
                    />
                ) : (
                    <Form.Control
                        disabled
                        className="mt-2"
                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal", fontSize: "14px"}}
                        type={type}
                        name={fieldName}
                        value={(value || value===0) ? value : ''}
                    />
                )}
            </div>
        );
    };

	return (
		<>
			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-9">
                    <Card>
                        <Card.Header><h4 className="card-title">Informazioni generali Lezione</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-6">
                                    {renderEditableField('name', 'Nome lezione', 'text')}
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-6">
                                    {renderEditableField('sportNames', 'Sport', 'text')}
                                </Col>
                                <Col className="col-xl-6">
                                    {renderEditableField('clubName', 'Struttura', 'text')}
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-12 text-center">
                                    <h4 className="text-center mb-0">Immagine del prodotto</h4>
                                    <br></br>
                                    {formData.lessonPicture ? 
                                        <img src={formData.lessonPicture} style={{maxHeight: '200px', maxWidth: '100%'}} alt="" /> 
                                    : 
                                        'Nessuna immagine caricata'
                                    }
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-12">
                                    {renderEditableField('description', 'Descrizione', 'textarea')}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Card>
                        <Card.Header><h4 className="card-title">Prezzi</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-6 mt-3">
                                    {renderEditableField('standard_price', 'Prezzo standard', 'number')}
                                </Col>
                                <Col className="col-xl-6 mt-3">
                                    <Form.Label>IVA</Form.Label>
                                    <Select
                                        isDisabled
                                        value={findVatOption(formData)}
                                        options={VAT_OPTIONS}
                                    />
                                </Col>
                                {showingTesseratiOptions && 
                                <Col className="col-xl-6 mt-3">
                                    {renderEditableField('federated_price', 'Prezzo riservato ai tesserati / soci', 'number')}
                                </Col>
                                }
                                <Col className="col-xl-6 mt-3">
                                    {renderEditableField('fitcoin_cashback', 'Cashback Fitcoin', 'number')}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Card>
                        <Card.Header><h4 className="card-title">Condizioni aggiuntive</h4></Card.Header>
                        <Card.Body>
                            <Row className="mt-4">
                                <Col className="col-xl-6">
                                    {renderEditableField('payable_in_club', 'Acquisto pagabile in struttura', 'select', optionsBoolean, true)}
                                </Col>
                                {paymentMethods.stripe_enabled && (
                                <Col className="col-xl-6">
                                    {renderEditableField('payable_stripe', 'Acquisto pagabile su Stripe', 'select', optionsBoolean, true)}
                                </Col>
                                )}
                                {paymentMethods.bank_transfer_enabled && (
                                <Col className="col-xl-6">
                                    {renderEditableField('payable_bank', 'Acquisto pagabile con bonifico', 'select', optionsBoolean, true)}
                                </Col>
                                )}
                            </Row>
                            
                        </Card.Body>
                    </Card>
                    

                    
                    <Card className="mt-4">
                        <Card.Header>
                            <Card.Title>Programmazione</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-12">
                                    <Form.Label className="mb-3">Programmazione settimanale</Form.Label>
                                    {formData.weeklySchedule && formData.weeklySchedule.length > 0 ? (
                                        formData.weeklySchedule.map((item, index) => (
                                            <Row key={index} className="mb-3">
                                                <Col className="col-xl-4">
                                                    <Form.Label>Giorno</Form.Label>
                                                    <Select
                                                        isDisabled
                                                        value={dayOptions.find(option => option.value === item.dayOfWeek)}
                                                        options={dayOptions}
                                                        placeholder="Seleziona giorno"
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                backgroundColor: '#f2f2f2',
                                                                color: 'rgba(108,117,125,0.6)',
                                                                border: '1px solid #ced4da'
                                                            }),
                                                            singleValue: (provided) => ({
                                                                ...provided,
                                                                color: 'rgba(108,117,125,0.6)'
                                                            })
                                                        }}
                                                    />
                                                </Col>
                                                <Col className="col-xl-4">
                                                    <Form.Label>Ora inizio</Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        className="mt-2"
                                                        style={{
                                                            color: 'rgba(108,117,125,0.6)', 
                                                            backgroundColor: '#f2f2f2', 
                                                            paddingLeft: "15px", 
                                                            fontWeight: "normal"
                                                        }}
                                                        type="time"
                                                        value={item.startTime}
                                                    />
                                                </Col>
                                                <Col className="col-xl-4">
                                                    <Form.Label>Ora fine</Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        className="mt-2"
                                                        style={{
                                                            color: 'rgba(108,117,125,0.6)', 
                                                            backgroundColor: '#f2f2f2', 
                                                            paddingLeft: "15px", 
                                                            fontWeight: "normal"
                                                        }}
                                                        type="time"
                                                        value={item.endTime}
                                                    />
                                                </Col>
                                            </Row>
                                        ))
                                    ) : (
                                        <p style={{color: 'rgba(108,117,125,0.6)', fontStyle: 'italic'}}>Nessuna programmazione settimanale configurata</p>
                                    )}
                                </Col>
                            </Row>
                                            </Card.Body>
                                        </Card>
                </div>
                <div className="col-xl-3">
                    <Card>
                        <Card.Body className="text-left">
                            <div>
                                <h5 className="mb-3">Informazioni Lezione</h5>
                                <p className="mb-2">
                                    <strong>Informazioni generali:</strong> Visualizza tutti i dettagli della lezione selezionata, inclusi nome, sport, durata e prezzi.
                                </p>
                                <p className="mb-2">
                                    <strong>Acquisti:</strong> Consulta l'elenco completo degli acquisti di questa lezione da parte degli utenti.
                                </p>
                            </div>
                            <hr className="my-3" />
                            {formData.status==='PURCHASABLE' && <div>Questa lezione è <b>Attivo</b> quindi sarà visibile agli utenti che cercano la tua struttura sull'app SportID.</div>}
                            {formData.status==='DRAFT' && <div>Questa lezione è in <b>Bozza</b> quindi non è ancora visibile agli utenti che cercano la tua struttura sull'app SportID.</div>}
                            {formData.status==='CANCELLED' && <div>Questa lezione è <b>Non attivo</b> quindi non è più visibile agli utenti che cercano la tua struttura sull'app SportID.</div>}
                        </Card.Body>
                    </Card>
                </div>
            </Row>
		</>
	)

}
export default AdminLessonsView;